// Kleine UI-/Format-Helfer für die Wartungen-Welt.

export function slugifyKey(input: string): string {
  return String(input || "")
    .toLowerCase()
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/ä/g, "ae")
    .replace(/ö/g, "oe")
    .replace(/ü/g, "ue")
    .replace(/ß/g, "ss")
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "")
    .replace(/_{2,}/g, "_");
}

/** Eindeutigen Slug erzeugen, der nicht in `existing` vorkommt. */
export function uniqueKey(base: string, existing: Set<string>, fallback = "feld"): string {
  const key = slugifyKey(base) || fallback;
  if (!existing.has(key)) return key;
  let i = 2;
  while (existing.has(`${key}_${i}`)) i += 1;
  return `${key}_${i}`;
}

export function formatStatus(status?: string | null): string {
  const map: Record<string, string> = {
    draft: "Entwurf",
    active: "Aktiv",
    inactive: "Inaktiv",
    expired: "Abgelaufen",
    published: "Veröffentlicht",
    open: "Offen",
    done: "Abgeschlossen",
    completed: "Abgeschlossen",
    in_progress: "In Bearbeitung",
  };
  if (!status) return "—";
  return map[String(status).toLowerCase()] || String(status);
}

export function formatDate(value?: string | null): string {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" });
}

export function formatDateValue(mode?: string | null, value?: string | null): string {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  if (mode === "year") return d.toLocaleDateString("de-DE", { year: "numeric" });
  if (mode === "month") return d.toLocaleDateString("de-DE", { month: "long", year: "numeric" });
  return d.toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" });
}
